<template>
  <div class="BlogFooter">

    <container>

      <nav class="BlogFooter-yearPicker"
        v-if="years">

        <router-link class="BlogFooter-yearPickerItem t-mono-xs"
          ref="item"
          v-for="year in years"
          :key="year.year"
          :to="year.route">

          {{ year.year }}

        </router-link>

      </nav>

      <break size="2" />

    </container>

  </div>
</template>

<script>
export default {
  name: 'BlogFooter',

  props: {
    years: {
      type: Array
    }
  }
}
</script>

<style>
@import 'properties';

.BlogFooter {
}

.BlogFooter-yearPicker {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: calc(-1 * var(--unit-025));
}

.BlogFooter-yearPickerItem {
  display: block;
  margin: 0 var(--unit-05) var(--unit-025);
}

.BlogFooter-yearPickerItem.router-link-active {
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// BlogFooter.vue?1e9b98ac